import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_SAL2070_R01 } from "./Content_SAL2070_R01";
import { Info_SAL2070_R01 } from "./Info_SAL2070_R01";
import { SearchSection_SAL2070_R01 } from "./SearchSection_SAL2070_R01";
import { useSAL2070_R01Store } from "./Store_SAL2070_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL2070_R01Dto, } from "./Dto_SAL2070_R01";
import { Table_SAL2070_R01 } from "./Table_SAL2070_R01";
import { DetailTable_SAL2070_R01 } from "./DetailTable_SAL2070_R01";


export const Container_SAL2070_R01 = () => {

	const { 
		allCount,
		initData, 
	} = useSAL2070_R01Store();

	
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'SAL2070_R01',
		type: 'width',
		storageKey: 'SAL2070_R01-split-width',
		min: 5,
		max: 80,
		default: 45
	} as const;
	const gridRef = useRef<AgGridReact<SAL2070_R01Dto>>(null);
	const detailGridRef = useRef<AgGridReact<SAL2070_R01Dto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'SAL2070_R01',
		type: 'height',
		storageKey: 'SAL2070_R01-info-split-height',
		min: 5,
		max: 80,
		default: 50
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		processVatRate,
		defaultSAL2070_R01HeaderRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_SAL2070_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={() => {}}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}	
		/>
		<SearchSection_SAL2070_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_SAL2070_R01 
					gridRef={gridRef} defaultSAL2070_R01HeaderRow={defaultSAL2070_R01HeaderRow()} 
				/>
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_SAL2070_R01
						defaultSAL2070_R01HeaderRow={defaultSAL2070_R01HeaderRow()}
						processVatRate={processVatRate}
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }}>
					<DetailTable_SAL2070_R01 gridRef={detailGridRef} />
				</div>
			</div>
		</div>
		<Message />
	</div>
}